module.exports = __webpack_public_path__ + "img/box_bg2.9f4f0cc.png";